import React from 'react';
import { Badge, Button, Card, CardBody } from 'reactstrap';
const DoneStep = ({ n, title, summary, onEdit, editLabel = "Change", actions = null }) => (
  <Card className="mb-2">
    <CardBody className="py-2 px-3 d-flex align-items-center justify-content-between gap-2">
      <div className="d-flex align-items-center gap-2 text-truncate">
        <Badge color="success" pill><i className="ri-check-line" /></Badge>
        <span className="text-muted fs-13 flex-shrink-0">{n}.</span>
        <span className="fw-medium text-truncate">{title}</span>
        {summary && (
          <span className="text-muted fs-13 text-truncate d-none d-sm-inline">{summary}</span>
        )}
      </div>
      <div className="d-flex align-items-center gap-2 flex-shrink-0">
        {actions}
        {onEdit && (
          <Button size="sm" color="link" className="p-0" onClick={onEdit}>
            {editLabel}
          </Button>
        )}
      </div>
    </CardBody>
  </Card>
);

/** The step being worked on. */
const ActiveStep = ({ n, title, children }) => (
  <Card className="mb-3">
    <CardBody>
      <h5 className="card-title mb-3">
        <Badge color="primary" className="me-2">{n}</Badge>
        {title}
      </h5>
      {children}
    </CardBody>
  </Card>
);


export { ActiveStep, DoneStep };
